export default function getNetworkStatus() {
  const result = {};
  const connection = navigator.connection;
  if (connection) {
    if (connection.type) result.networkType = connection.type;
    if (connection.effectiveType) result.networkEffectiveType = connection.effectiveType;
    if (typeof connection.saveData === 'boolean') result.networkSaveDataEnabled = connection.saveData;
  }
  return result;
}
